import { useTranslation } from 'react-i18next'
import { ProviderType } from '../generated/graphql'

type UseProviderNames = {
  typeToDefaultName: (providerType?: ProviderType) => string
}

export function useProviderNames(
  currentProviderNames: string[],
): UseProviderNames {
  const { t } = useTranslation()

  const typeToDefaultName = (providerType?: ProviderType) => {
    const suggestedName = providerType ? t(`providerType.${providerType}`) : ''

    if (!currentProviderNames.includes(suggestedName)) {
      return suggestedName
    }

    for (let i = 1; i < 100; i++) {
      const nextSuggestedName = `${suggestedName} (${i})`

      if (!currentProviderNames.includes(nextSuggestedName)) {
        return nextSuggestedName
      }
    }

    throw new Error(
      `Unable to generate default name for provider with type ${
        providerType ?? 'undefined'
      }.`,
    )
  }

  return {
    typeToDefaultName,
  }
}
